// extracted by mini-css-extract-plugin
export default {"feedback-history-form":"FeedbackHistoryForm_feedback-history-form__bIgfV","form-group":"FeedbackHistoryForm_form-group__BbeNW","error":"FeedbackHistoryForm_error__E+k5p"};